import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { mastercard, money, visapayment } from "../Constant/Index";
import { Link } from "react-router-dom";
import MyModal from "../Components/MyModal";

const BookAppointmentPayment = () => {
	const [selectedCard, setSelectedCard] = useState("");

	const handleCardClick = (card) => {
		setSelectedCard(card);
	};
	const [show, setShow] = useState(false);

	const handleShow = () => setShow(true);
	const handleClose = () => setShow(false);
	return (
		<>
			<Header />
			<PageHeader pagename="Total Amount" />
			<section className="payment-module">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="mainpaymnet">
								<h5 className=" main-heading-font">Choose Card</h5>
								<div className="d-flex align-items-start justify-content-between">
									<div className="d-flex align-items-center gap-3">
										<img
											src={visapayment}
											className={`img-fluid payment-card ${
												selectedCard === "visa" ? "selected" : ""
											}`}
											alt="Visa"
											onClick={() => handleCardClick("visa")}
										/>
										<img
											src={mastercard}
											className={`img-fluid payment-card ${
												selectedCard === "mastercard" ? "selected" : ""
											}`}
											alt="Mastercard"
											onClick={() => handleCardClick("mastercard")}
										/>
									</div>
									<div className="payment-wrapper">
										<h4 className="level-7 text-end">Total Amount</h4>
										<h3 className="main-heading-font level-3 text-end">
											$80.00
										</h3>
									</div>
								</div>
								<form action="" className="payment-form">
									<div className="row  mt-3">
										<div className="col-lg-12">
											<h3 className="main-heading-font level-7 ">
												Card Number
											</h3>
											<div className="form-group position-relative">
												<input
													type="number"
													className="form-control"
													id="firstName"
													placeholder="2048 2048 2048 2048"
												/>
												<div className="position-toggle">
													<img src={money} className="img-fluid" alt="" />
												</div>
											</div>
										</div>
										<div className="col-lg-12 mt-3">
											<h3 className="main-heading-font level-7 ">
												Card Holder Number
											</h3>
											<div className="form-group position-relative">
												<input
													type="number"
													className="form-control"
													id="firstName"
													placeholder="Enter name here"
												/>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-6">
											<h3 className="main-heading-font level-7 ">
												Expiry Date
											</h3>
											<div className="form-group position-relative">
												<input
													type="date"
													className="form-control"
													id="firstName"
													placeholder="Enter name here"
												/>
											</div>
										</div>
										<div className="col-lg-6">
											<h3 className="main-heading-font level-7 ">CVV</h3>
											<div className="form-group position-relative">
												<input
													type="number"
													className="form-control"
													id="firstName"
													placeholder="Enter 3 digit pin"
												/>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-lg-12">
											<Link
												class="start-now btn wrapper-btn-main log-in level-7 w-100 primary-regular-font text-decoration-none"
												href="/book-appointment"
												onClick={handleShow}
											>
												<span class="bg-wrapper w-100">GET STARTED</span>
											</Link>
										</div>
									</div>
								</form>
								<div className="row">
									<div className="col-lg-12">
										<MyModal show={show} handleClose={handleClose} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default BookAppointmentPayment;
